import React from 'react';
import Slider from 'react-slick';
import { ExternalLink } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Visionnaire Images - 12 total including yacht interiors, luxury residential interiors from visionnaire-home.com
const visionnaireImages = [
  // User uploaded yacht images (Ulysses Yacht)
  'https://customer-assets.emergentagent.com/job_maison-eze/artifacts/ozvo29tq_Ulysses%20Yacht%20nl44.jpeg',
  'https://customer-assets.emergentagent.com/job_maison-eze/artifacts/xkui0a8m_Ulysses%20Yacht%20nl2.jpeg',
  'https://customer-assets.emergentagent.com/job_maison-eze/artifacts/1rfi5i6p_Ulysses%20Yacht%20nl4.jpeg',
  'https://customer-assets.emergentagent.com/job_maison-eze/artifacts/cs8tfzqn_Ulysses%20Yacht%20nl23.jpeg',
  'https://customer-assets.emergentagent.com/job_maison-eze/artifacts/ni8mhz69_Ulysses%20Yacht%20nl75.jpeg',
  // Visionnaire Residential Interiors from visionnaire-home.com
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1763044166/visionnaire_website_prd/Visionnaire_Chiostro_Project_Website_1_d2d9bb011a',
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1752854389/visionnaire_website_prd/Lumea_f_6539ba8252',
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1753716635/visionnaire_website_prd/Sunny_Isles_Villa_b_01_a9cbbecabc',
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1753686552/visionnaire_website_prd/Parco_Chigi_hero_eab3fc4022',
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1753781868/visionnaire_website_prd/Romantic_Chateaux_f_5353eabeb9',
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1753449349/visionnaire_website_prd/Canon_Drive_f_D_e0cbf00ef9',
  'https://res.cloudinary.com/dpups1csk/image/upload/c_limit,w_1920/f_auto/q_auto:best/v1753716849/visionnaire_website_prd/Monaco_f_e192116530'
];

// Serenity Living Images - 5 images from serenity-living.gr/apartments
const serenityLivingImages = [
  'https://static.wixstatic.com/media/55275b_5d07c38f7991413595ad3b00027cff60~mv2.jpg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/SAP_EXT_F06B_6K.jpg',
  'https://static.wixstatic.com/media/55275b_3f0c4bd14b8f480588ef0716c78fdf3c~mv2.jpg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/SAP_INT_F01_6K.jpg',
  'https://static.wixstatic.com/media/55275b_14f0418142f745f2bd2da75f4e17477d~mv2.jpg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/SAP_INT_F02_6K.jpg',
  'https://static.wixstatic.com/media/55275b_2ff6da09a23e40bf87388e3402b7c808~mv2.jpg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/SAP_EXT_F07_6K.jpg',
  'https://static.wixstatic.com/media/55275b_fe399810339043a0820680de4627fe5a~mv2.jpg/v1/fill/w_1200,h_800,al_c,q_85,enc_avif,quality_auto/55275b_fe399810339043a0820680de4627fe5a~mv2.jpg'
];

// Sara Bradstock Racing Images - 5 images (Elite horse racing)
const saraBradstockImages = [
  'https://images.pexels.com/photos/158976/pexels-photo-158976.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/3015224/pexels-photo-3015224.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?w=1200&q=85',
  'https://images.unsplash.com/photo-1463748465553-80db1e6ff830?w=1200&q=85',
  'https://images.pexels.com/photos/52500/horse-herd-fog-nature-52500.jpeg?auto=compress&cs=tinysrgb&w=1200'
];

const partners = [
  {
    name: 'Serenity Living',
    category: 'Development Partner',
    description: 'Exclusive luxury apartments in the heart of Athens Riviera, Vouliagmeni. Premium coastal living at its finest.',
    url: 'https://www.serenity-living.gr',
    images: serenityLivingImages
  },
  {
    name: 'Sara Bradstock Racing',
    category: 'Lifestyle & Sport',
    description: 'Elite National Hunt racehorse training and ownership experiences for discerning enthusiasts seeking the thrill of horse racing.',
    url: 'https://sarabradstockracing.com/',
    images: saraBradstockImages
  }
];

const Partners = () => {
  const { t } = useTranslation();

  // Carousel settings for featured partner (larger, slower)
  const featuredCarouselSettings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    pauseOnHover: true,
    arrows: false,
    cssEase: 'ease-in-out'
  };

  // Carousel settings for other partners
  const carouselSettings = {
    dots: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    fade: true,
    pauseOnHover: true,
    arrows: false,
    cssEase: 'ease-in-out'
  };

  return (
    <section className="section-padding" style={{ background: '#fffef2', borderTop: '1px solid rgba(51,51,51,0.1)' }}>
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6">{t.partners.title}</h2>
          <div className="w-20 h-px bg-gray-300 mx-auto mb-6"></div>
          <p className="body-regular" style={{ color: '#666666', maxWidth: '700px', margin: '0 auto' }}>
            {t.partners.subtitle}
          </p>
        </div>

        {/* Featured Partner - Visionnaire (Large Rectangular Section) */}
        <div className="mb-16">
          <a
            href="https://www.visionnaire-home.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group block transition-all duration-500"
            style={{
              background: '#1a1a1a',
              borderRadius: '0px',
              border: '1px solid rgba(201,169,97,0.3)',
              overflow: 'hidden',
              boxShadow: '0 20px 60px rgba(0,0,0,0.15)'
            }}
          >
            {/* Large rectangular layout */}
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-0">
              {/* Image Carousel - Takes 3/5 of the width */}
              <div className="relative lg:col-span-3 h-[400px] lg:h-[550px] overflow-hidden">
                <Slider {...featuredCarouselSettings}>
                  {visionnaireImages.map((image, index) => (
                    <div key={index} className="relative h-[400px] lg:h-[550px]">
                      <img
                        src={image}
                        alt={`Visionnaire ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                      <div className="absolute inset-0 bg-gradient-to-r from-black/30 via-transparent to-transparent"></div>
                    </div>
                  ))}
                </Slider>
                
                {/* Featured badge */}
                <div className="absolute top-6 left-6 z-10">
                  <span
                    className="body-small px-5 py-2.5 inline-block"
                    style={{
                      background: 'linear-gradient(135deg, #C9A961 0%, #E8D5A3 50%, #C9A961 100%)',
                      color: '#1a1a1a',
                      textTransform: 'uppercase',
                      letterSpacing: '0.15em',
                      fontSize: '11px',
                      fontWeight: 600
                    }}
                  >
                    Featured Partner
                  </span>
                </div>
                
                {/* Image counter */}
                <div className="absolute bottom-6 left-6 z-10">
                  <span
                    className="px-3 py-1.5 inline-block"
                    style={{
                      background: 'rgba(0,0,0,0.6)',
                      color: '#fffef2',
                      fontSize: '11px',
                      letterSpacing: '0.1em'
                    }}
                  >
                    {visionnaireImages.length} IMAGES
                  </span>
                </div>
              </div>

              {/* Content - Takes 2/5 of the width */}
              <div className="lg:col-span-2 p-10 lg:p-14 flex flex-col justify-center" style={{ background: '#1a1a1a' }}>
                <span
                  className="body-small mb-4 block"
                  style={{
                    color: '#C9A961',
                    textTransform: 'uppercase',
                    letterSpacing: '0.2em',
                    fontSize: '11px',
                    fontWeight: 500
                  }}
                >
                  Ultra-Luxury Interiors & Yachting
                </span>

                <h3 
                  className="mb-6 flex items-center justify-between" 
                  style={{ 
                    fontSize: '42px',
                    fontWeight: 300,
                    color: '#fffef2',
                    letterSpacing: '-0.02em',
                    lineHeight: 1.1
                  }}
                >
                  <span>Visionnaire</span>
                  <ExternalLink
                    className="w-7 h-7 transition-all duration-300 group-hover:translate-x-2 group-hover:-translate-y-2"
                    style={{ color: '#C9A961' }}
                  />
                </h3>

                <p className="mb-8" style={{ color: '#a0a0a0', lineHeight: 1.8, fontSize: '15px' }}>
                  Italian artisan excellence in bespoke ultra-luxury interiors and furniture. 
                  Marine-certified specialists creating extraordinary living spaces for superyachts 
                  and exclusive residences worldwide, including the prestigious Mareterra Monte Carlo development.
                </p>

                {/* Tags */}
                <div className="flex flex-wrap gap-2 mb-8">
                  {['Bespoke Interiors', 'Yacht Design', 'Marine Certified', 'Mareterra Monte Carlo', 'Italian Craftsmanship'].map((tag, idx) => (
                    <span
                      key={idx}
                      className="px-4 py-1.5"
                      style={{
                        background: 'rgba(201,169,97,0.15)',
                        color: '#C9A961',
                        fontSize: '10px',
                        textTransform: 'uppercase',
                        letterSpacing: '0.1em',
                        border: '1px solid rgba(201,169,97,0.3)'
                      }}
                    >
                      {tag}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <div className="pt-8 border-t" style={{ borderColor: 'rgba(201,169,97,0.2)' }}>
                  <span 
                    className="inline-flex items-center gap-2 transition-all duration-300 group-hover:gap-4" 
                    style={{ color: '#C9A961', fontWeight: 500, fontSize: '14px', letterSpacing: '0.05em' }}
                  >
                    {t.partners.visitWebsite}
                    <span style={{ fontSize: '18px' }}>→</span>
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>

        {/* Other Partners Grid - 2 columns for 2 partners */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {partners.map((partner, index) => (
            <a
              key={index}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group block transition-all duration-300 hover:shadow-xl"
              style={{
                background: '#f6f5e8',
                borderRadius: '0px',
                border: '1px solid rgba(51,51,51,0.1)',
                overflow: 'hidden'
              }}
            >
              {/* Image Carousel */}
              <div className="relative h-64 overflow-hidden">
                <Slider {...carouselSettings}>
                  {partner.images.map((image, imgIndex) => (
                    <div key={imgIndex} className="relative h-64">
                      <img
                        src={image}
                        alt={`${partner.name} ${imgIndex + 1}`}
                        className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                      />
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-all duration-300"></div>
                    </div>
                  ))}
                </Slider>
                
                {/* Image counter badge */}
                <div className="absolute bottom-3 right-3 z-10">
                  <span
                    className="px-2 py-1 inline-block"
                    style={{
                      background: 'rgba(0,0,0,0.5)',
                      color: '#fff',
                      fontSize: '10px',
                      letterSpacing: '0.05em'
                    }}
                  >
                    {partner.images.length} IMAGES
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col h-auto">
                <span
                  className="body-small mb-3"
                  style={{
                    color: '#C9A961',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    fontSize: '11px',
                    fontWeight: 500
                  }}
                >
                  {partner.category}
                </span>

                <h3 className="heading-2 mb-3 flex items-center justify-between" style={{ fontSize: '20px', fontWeight: 500 }}>
                  {partner.name}
                  <ExternalLink
                    className="w-4 h-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                    style={{ color: '#C9A961' }}
                  />
                </h3>

                <p className="body-small flex-grow mb-4" style={{ color: '#666666', lineHeight: 1.6, fontSize: '13px' }}>
                  {partner.description}
                </p>

                <div className="pt-4 border-t" style={{ borderColor: 'rgba(51,51,51,0.1)' }}>
                  <span className="body-small transition-all duration-300 group-hover:text-[#C9A961]" style={{ color: '#333333', fontSize: '13px' }}>
                    {t.partners.visitWebsite} →
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
